import {objectToListOptions} from "@/helpers/common";
import {isPublicRoute} from "@/helpers/common";

const state = () => ({
  btnLoading: false,
  isPageLoading: false,
  errors: [],
  fromPage: 'frontend',
  settings: null,
  company: null,
  breadCrumb: [],
  defaultBreadCrumb: {
    name: 'dashboard',
    path: '/dashboard',
  },
})

const actions = {
  async nuxtServerInit({dispatch, state, commit}, {req}) {
    const url = req.url;
    await dispatch('getSetting');

    if (/^\/admin/.test(url)) {
      state.fromPage = 'admin';
      await dispatch('admin/auth/initAuthState', {req});
      return;
    }

    state.fromPage = 'frontend';
    await dispatch('frontend/auth/initAuthState', {req, isPublicRoute: isPublicRoute(url)});
    if (state.frontend.auth.token) {
      if(!isPublicRoute(url)) {
        await dispatch('frontend/proposals/getListByMonth');
      }
    }
  },
  async getSetting({commit}) {
    const response = await this.$axios.get('v1/get-settings');
    if (response.status === 200) {
      commit('setSettings', response.data);
      return response.data;
    }
  },
  fakeFromPage({commit}, page) {
    commit('setFromPage', page)
  }
}

const getters = {
  getBtnLoading: (state) => state.btnLoading,
  getErrors: (state) => state.errors,
  getSettings: (state) => state.settings,
  getHealthInsurance: state => {
    return objectToListOptions(state.settings.company_info.health_insurance);
  },
  getPensionInsurance: state => {
    return objectToListOptions(state.settings.company_info.pension_insurance);
  },
  getLongtermCareInsurance: state => {
    return objectToListOptions(state.settings.company_info.longterm_care_insurance);
  },
  getEmploymentInsurance: state => {
    return objectToListOptions(state.settings.company_info.employment_insurance);
  },
  getLaborAccidentInsurance: state => {
    return objectToListOptions(state.settings.company_info.labor_accident_insurance);
  },
  getBreadCrumb: state => payload => {
    let path;

    switch (payload) {
      case 'admin':
        path = '/admin';
        break;
      default:
        path = '/dashboard';
    }
    if(payload != 'admin ' && state.defaultBreadCrumb.path != '/dashboard') {
      return [
        ...state.breadCrumb
      ];
    }
    return [{
      name: 'dashboard',
      path
    },...state.breadCrumb]
  },
  getFieldTypesApplication: state => {
    const fieldTypes = state.settings.data.applications.fieldType;
    const fieldTypesJp = state.settings.data.applications.fieldTypeJp;

    return Object.values(fieldTypes).map(value => ({
      text: fieldTypesJp[value],
      value: parseInt(value)
    })).filter(item => Boolean(item.text));
  },
  getIncrementTag: state => {
    const tag = state.settings.data.applications.incrementTag;

    return tag.prefix + tag.text;
  },
  saleAvailable: state => {
    const roles = state.company.roles;

    return roles.length > 1;
  },
  getRoles: state => state.company.roles
}

const mutations = {
  setBtnLoading: (state, payload) => state.btnLoading = payload,
  setErrors: (state, payload) => state.errors = payload,
  resetErrors: state => state.errors = [],
  setSettings: (state, payload) => state.settings = payload,
  setBreadCrumb: (state, payload) => state.breadCrumb = payload,
  setDefaultBreadCrumb: (state, payload) => state.defaultBreadCrumb = payload,
  showPageLoading: state => state.isPageLoading = true,
  hidePageLoading: state => state.isPageLoading = false,
  setCompany: (state, payload) => state.company = payload,
  setFromPage: (state, page) => state.fromPage = page
}

export default {
  state,
  getters,
  mutations,
  actions
}
